module.exports = __webpack_public_path__ + "static/media/cart.fb08a8f9.svg";